import {frontBaseUrl, frontEndType, signUpLink} from "../../build_constants.ts";
import {FRONT_END_TYPE} from "../../constants.ts";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

interface ContentProps {
    disableSignup?: boolean;
}

export default function SignUpAndFindAccountBlock({disableSignup}: ContentProps = {disableSignup: false}) {
    const {t} = useTranslation('ui');

    if (frontEndType === FRONT_END_TYPE.XSLAB) {
        return (
            <div className="row mt-4">
                <p className="col-md-4 txt-do-not-have-an-account">
                    {t("login.noAccount")}
                </p>

                <Link
                    className="col-md-4 fw-medium text-primary anchor-sign-up"
                    to={signUpLink}
                    aria-label={t("login.signUp")}
                >
                    {t("login.signUp")}
                </Link>

                {!disableSignup && (
                    <Link
                        className="col-md-4 fw-medium text-primary anchor-find-account"
                        to={`${frontBaseUrl}/find_id`}
                        aria-label={t("login.findAccount")}
                    >
                        {t("login.findAccount")}
                    </Link>
                )}
            </div>
        );
    }

    return <></>;
}
